<template>
	<form @submit.prevent="handleSubmit" class="phone-login-form">
		<div class="form-group">
			<label class="form-label">用户名</label>
			<input v-model="phone" type="text" class="form-input" placeholder="请输入用户名" />
		</div>

		<div class="form-group">
			<label class="form-label">密码</label>
			<div class="input-with-button">
				<input v-model="code" type="password" class="form-input" placeholder="请输入密码" />
				<!-- <button type="button" class="send-code-btn" :disabled="!canSendCode || countdown > 0" @click="sendCode">
					{{ countdown > 0 ? `${countdown}秒后重试` : '获取验证码' }}
				</button> -->
			</div>
		</div>

		<button type="submit" class="submit-btn" >
			登录(log on)
		</button>
	</form>
</template>

<script>
	export default {
		name: 'PhoneLogin',

		data() {
			return {
				phone: '',
				code: '',
				countdown: 0,
				timer: null
			}
		},

		computed: {
			canSendCode() {
				return /^1[3-9]\d{9}$/.test(this.phone)
			},

			canSubmit() {
				return this.canSendCode && /^\d{6}$/.test(this.code)
			}
		},

		methods: {
			validatePhone() {
				this.phone = this.phone.replace(/\D/g, '')
			},

			sendCode() {
				if (!this.canSendCode) {
					this.$store.dispatch('showToast', '请输入正确的手机号')
					return
				}
				this.HttpUtils.post('/api/wxmini/VISITOR/send', {
					phone: this.phone,
					region: '+86'
				}).then(res => {
					console.log(res)
					if (res.data.code === 200) {
						// sessionStorage.setItem('token', res.token)
						// sessionStorage.setItem('currentUser', res.data)
						// 开始倒计时
						this.countdown = 60
						this.timer = setInterval(() => {
							this.countdown--
							if (this.countdown <= 0) {
								clearInterval(this.timer)
							}
						}, 1000)

						// 发送验证码
						this.$store.dispatch('showToast', '验证码已发送')
						// this.$router.push({
						//   path: '/index'
						// })
					} else {
						this.$message.error(res.data.msg)
					}
				})


			},

			handleSubmit() {
				if (!this.phone) {
					this.$message.error('请输入用户名');
					return
				}
				if (!this.code) {
					this.$message.error('请输入密码');
					return
				}
				this.HttpUtils.post('/api/wxmini/loginWeb', {
					username: this.phone,
					password: this.code
				}).then(res => {
					console.log(res)
					if (res.data.code === 200) {
						// ruoyi 后端返回：{ code, msg, token, user }
						sessionStorage.setItem('token', res.data.token)
						sessionStorage.setItem('currentUser', JSON.stringify(res.data.user))
						// 2. 更新Vuex store（关键步骤）
						this.$store.commit('SET_USER', res.data.user)
						// 模拟登录
						this.$store.dispatch('showToast', '登录成功')
						// this.$router.push({
						// 	path: '/'
						// })
						// 🔄 智能重定向：登录成功后跳转到原来要访问的页面
						const redirectPath = this.$route.query.redirect || '/index'
						this.$router.push(redirectPath)
					} else {
						this.$message.error(res.data.msg)
					}
				}).catch(error => {
					console.error('登录失败:', error)
					this.$message.error('登录失败，请重试')
				})
			}
		},

		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer)
			}
		}
	}
</script>

<style scoped>
	.phone-login-form {
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.form-group {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.form-label {
		font-size: 14px;
		font-weight: 500;
		color: var(--text-dark);
	}

	.form-input {
		width: 100%;
		padding: 16px 20px;
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		font-size: 17px;
		background: rgba(255, 255, 255, 0.5);
		transition: all 0.3s;
	}

	.form-input:focus {
		outline: none;
		border-color: var(--primary);
		background: rgba(255, 255, 255, 0.8);
		box-shadow: 0 0 0 4px rgba(0, 122, 255, 0.1);
	}

	.input-with-button {
		display: flex;
		gap: 12px;
	}

	.send-code-btn {
		flex-shrink: 0;
		padding: 16px 24px;
		background: var(--bg-glass);
		border: 1px solid var(--border-light);
		border-radius: var(--radius-md);
		font-size: 16px;
		font-weight: 500;
		color: var(--primary);
		cursor: pointer;
		transition: all 0.3s;
		white-space: nowrap;
	}

	.send-code-btn:hover:not(:disabled) {
		background: rgba(0, 122, 255, 0.05);
		border-color: var(--primary);
	}

	.send-code-btn:disabled {
		opacity: 0.6;
		cursor: not-allowed;
		color: var(--text-light);
	}

	.submit-btn {
		width: 100%;
		padding: 18px;
		background: linear-gradient(135deg, var(--primary), var(--secondary));
		color: white;
		border: none;
		border-radius: var(--radius-md);
		font-size: 18px;
		font-weight: 600;
		cursor: pointer;
		transition: all 0.3s;
		box-shadow: 0 8px 32px rgba(0, 122, 255, 0.3);
	}

	.submit-btn:hover:not(:disabled) {
		transform: translateY(-2px);
		box-shadow: 0 12px 40px rgba(0, 122, 255, 0.4);
	}

	.submit-btn:disabled {
		background: var(--text-light);
		cursor: not-allowed;
		box-shadow: none;
	}
</style>